<div class="logOuterContainer">
  <p-panel [styleClass]="'logFrame'" [header]="uiText.COMMUNICATION_LOG_ENTRIES | hisUi">
    <div class="logInnerContainer" #logContainer>
      @if (logEntries?.length === 0) {
        <div class="infoMessage">
          {{ uiText.COMMUNICATION_LOG_ENTRY_EMPTY_MESSAGE | hisUi }}
        </div>
      }
      @for (entry of logEntries; track entryId($index, entry)) {
        <his-communication-log-entry
          [entry]="entry"
          [domainsByIdMap]="domainsById"
          (editEntry)="editEntryById($event)"
          (deleteEntry)="deleteEntryById($event)">
        </his-communication-log-entry>
      }
    </div>
    <p-footer>
      @if (!isDataComplete) {
        <button type="button"
          hisImage="ARROW_ROTATE_CLOCKWISE"
          (click)="requestMoreEntries.emit()"
          class="submit_linkLook">
          {{ uiText.LOAD_MORE | hisUi }}
        </button>
      }
      @if (isDataComplete) {
        <span
          class="communicationLogFooter">
          {{ uiText.DATA_LOADED_COMPLETELY | hisUi }}
        </span>
      }
    </p-footer>
  </p-panel>
</div>
